import axios from '@/common/axiosPlugin.js';

let tencentApiUrl = '/ws/direction/v1/driving/?from=39.915285,116.403857&to=39.915285,116.803857&waypoints=39.111,116.112;39.112,116.113&output=json&callback=callbackMethod&key=PCQBZ-SJOWX-4CP4R-TAK7B-HKZHJ-XABYI';
let mockUrl1 = '/parameter/query1';
let mockUrl2 = '/parameter/query2';

let loginTestUrl = '/api/user/login-test';

let checkLoginUrl = '/api/user/checkLogin';
let loginUrl = '/api/user/login';
let logoutUrl = '/api/user/logout';
let signinUrl = '/api/user/signin';
let signinSendMailCodeUrl = '/api/user/signinSendMailCode';
let forgetPasswordSendMailCodeUrl = '/api/user/forgetPasswordSendMailCode';
let settingsUrl = '/api/user/settings';
let getUserInfoUrl = '/api/user/user-info';
let nameGetInfoUrl = '/api/user/name-get-info';
let authorTopUrl = '/api/user/author-top';
let settingPasswordUrl = '/api/user/setting-password';
let resetPasswordUrl = '/api/user/reset-password';
let followDoUrl = '/api/follow/do';
let followUndoUrl = '/api/follow/undo';
let followeeUrl = '/api/follow/followee';
let followerUrl = '/api/follow/follower';

let uploadUrl = '/oss/upload/image';

// let uploadUrl = '/api/ecs/img';
let bloglistUrl = '/api/blog/list';
let blogdetailUrl = '/api/blog/detail';
let blogdelUrl = '/api/blog/del';
let blogupdateUrl = '/api/blog/update';
let blogaddUrl = '/api/blog/new';
let blogpraiseUrl = '/api/blog/praise';
let blogcommentUrl = '/api/blog/comment';
let delcommentUrl = '/api/blog/comment/del';

export let tencentApi = (data) => {
  return axios.get(tencentApiUrl, data)
    .then(resData => {
      return resData;
    });
};
export let mockApi1 = (data) => {
  return axios.get(mockUrl1, data)
    .then(resData => {
      return resData;
    });
};
export let mockApi2 = (data) => {
  return axios.get(mockUrl2, data)
    .then(resData => {
      return resData;
    });
};
export let checkLoginApi = (data) => {
  return axios.post(checkLoginUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let loginApi = (data) => {
  return axios.post(loginUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let logoutApi = () => {
  return axios.post(logoutUrl)
    .then(resData => {
      return resData;
    });
};
export let loginTestApi = (data) => {
  return axios.get(loginTestUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let signinApi = (data) => {
  return axios.post(signinUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let signinSendMailCodeApi = (data) => {
  return axios.post(signinSendMailCodeUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let forgetPasswordSendMailCodeApi = (data) => {
  return axios.post(forgetPasswordSendMailCodeUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let settingsApi = (data) => {
  return axios.post(settingsUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let getUserInfoApi = (data) => {
  return axios.post(getUserInfoUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let nameGetInfoApi = (data) => {
  return axios.post(nameGetInfoUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let followDoApi = (data) => {
  return axios.post(followDoUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let followUndoApi = (data) => {
  return axios.post(followUndoUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let followeeApi = (data) => {
  return axios.post(followeeUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let followerApi = (data) => {
  return axios.post(followerUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let authorTopApi = (data) => {
  return axios.post(authorTopUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let settingPassworApi = (data) => {
  return axios.post(settingPasswordUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let resetPasswordApi = (data) => {
  return axios.post(resetPasswordUrl, JSON.stringify(data))
    .then(resData => {
      return resData;
    });
};
export let uploadApi = (data) => {
  return axios.post(uploadUrl, data)
    .then(resData => {
      return resData;
    });
};
export let bloglistApi = (data = '') => {
  return axios.get(bloglistUrl + data)
    .then(resData => {
      return resData;
    });
};
export let blogdetailApi = (data = '') => {
  return axios.get(blogdetailUrl + data)
    .then(resData => {
      return resData;
    });
};
export let blogdelApi = (data) => {
  return axios.post(blogdelUrl, data)
    .then(resData => {
      return resData;
    });
};
export let blogupdateApi = (data) => {
  return axios.post(blogupdateUrl, data)
    .then(resData => {
      return resData;
    });
};
export let blogaddApi = (data) => {
  return axios.post(blogaddUrl, data)
    .then(resData => {
      return resData;
    });
};
export let blogpraiseApi = (data) => {
  return axios.post(blogpraiseUrl, data)
    .then(resData => {
      return resData;
    });
};
export let blogcommentApi = (data) => {
  return axios.post(blogcommentUrl, data)
    .then(resData => {
      return resData;
    });
};
export let delcommentApi = (data) => {
  return axios.post(delcommentUrl, data)
    .then(resData => {
      return resData;
    });
};



// WEBPACK FOOTER //
// ./src/views/apis/index.js